export default __webpack_public_path__ + "static/media/蚊香社.d21e4c86.png";